import { useApi } from "@/hooks";
import { Api } from "@Shared/schemas";
import { TrainingFocus } from "@Shared/schemas/progression/progressionSchemas";
import { useCallback, useEffect, useState } from "react";

export const useTrainingFocus = () => {
  const [trainingFocus, setTrainingFocus] = useState<TrainingFocus | null>(null);
  const [hasLoadedTrainingFocus, setHasLoadedTrainingFocus] = useState(false);
  const { call, loading } = useApi<typeof Api.Progression.GetTrainingFocus>({
    api: Api.Progression.GetTrainingFocus,
    disableLoader: true,
  });

  const loadTrainingFocus = useCallback(
    async (recalculate = false) => {
      call({ recalculate })
        .then(response => {
          setTrainingFocus(response.data);
          return response.data;
        })
        .finally(() => {
          setHasLoadedTrainingFocus(true);
        });
    },
    [call]
  );
  useEffect(() => {
    loadTrainingFocus();
  }, [loadTrainingFocus]);
  return { trainingFocus, loading, hasLoadedTrainingFocus, recalculate: () => loadTrainingFocus(true) };
};
